const ParentGraphic = () => {
    return (<section className="graphic-section graphic-section--parents"></section>
    );
}

export default ParentGraphic;